<template>
  <PointsApi />
</template>

<script>
import PointsApi from '../components/PointsApi.vue';

export default {
    components: {
        PointsApi,
    },
};
</script>
